
export { new_user, heard_from_other };

import { Utils } from '../lib/utils.js';

function heard_from_other(value) {
	if (value == 'other') {
		document.getElementById('heard_from_detail_block').style.display = '';
	} else {
		document.getElementById('heard_from_detail_block').style.display = 'none';
	}
}

function new_user(target) {

	var has_error = false;

	var plan_selection_block = document.getElementById('plan_selection_block');
	var plan_selection, plan_selection2, plan_selection3;

	var first_name           = document.getElementById('first_name');
	var last_name            = document.getElementById('last_name');

	var email                = document.getElementById('email');
	var email_confirm        = document.getElementById('email_confirm');
	var password             = document.getElementById('password');
	var password_confirm     = document.getElementById('password_confirm');
	var terms_of_use         = document.getElementById('terms_of_use');
	var terms_of_use_label   = document.getElementById('terms_of_use_label');

	var position             = document.getElementById('position');

	var level_uni            = document.getElementById('level_uni');
	var level_jc             = document.getElementById('level_jc');
	var level_hs             = document.getElementById('level_hs');
	var level_ms             = document.getElementById('level_ms');
	var level_club           = document.getElementById('level_club');
	var level_other          = document.getElementById('level_other');

	var level2_v             = document.getElementById('level2_v');
	var level2_jv            = document.getElementById('level2_jv');
	var level2_c18           = document.getElementById('level2_c18');
	var level2_c16           = document.getElementById('level2_c16');
	var level2_c14           = document.getElementById('level2_c14');
	var level2_c12           = document.getElementById('level2_c12');

	var gender_m             = document.getElementById('gender_male');
	var gender_f             = document.getElementById('gender_female');

	var org                  = document.getElementById('org');
	var city                 = document.getElementById('city');
	var state                = document.getElementById('state');

	var heard_from           = document.getElementById('heard_from');
	var heard_from_detail    = document.getElementById('heard_from_detail');

	var regkind              = document.getElementById('regkind');
	var redirect             = document.getElementById('redirect');
	var avcaemail            = document.getElementById('avcaemail');

	// get plan selection
	$("input[name='plan_selection']").each(function () {
		if ($(this).attr("checked")) {
			plan_selection = $(this).val();
			var level;
			if (plan_selection === "bundle") {
				// get the chosen length
				level = $(this).data("level");
				plan_selection2 = level;
				plan_selection3 = $("select[name='bundle_" + level + "_length']").val();
			} else if (plan_selection === "winnow") {
				level = $(this).data("level");
				plan_selection2 = level;
			}
		}
	});

	if (!plan_selection && plan_selection_block) {
		plan_selection_block.style.border = '2px solid red';
		has_error = true;
	}

	if (first_name.value && first_name.value != 'First Name') {
		first_name.style.border = '';
	} else {
		first_name.style.border = '2px solid red';
		has_error = true;
	}

	if (last_name.value && last_name.value != 'Last Name') {
		last_name.style.border = '';
	} else {
		last_name.style.border = '2px solid red';
		has_error = true;
	}

	if (email.value && Utils.checkEmail(email.value)) {
		email.style.border = '';
	} else {
		email.style.border = '2px solid red';
		has_error = true;
	}

	if (email_confirm.value) {
		email_confirm.style.border = '';
	} else {
		email_confirm.style.border = '2px solid red';
		has_error = true;
	}

	if (email.value && email_confirm.value) {
		if (email.value != email_confirm.value) {
			email.style.border = '2px solid red';
			email_confirm.style.border = '2px solid red';
			has_error = true;
		}
		if (!Utils.isAscii(email.value)) {
			has_error = true;
			alert("Only letters, numbers, underscores, and one dot (.) are allowed in your e-mail address");
		}
	}

	if (password.value) {
		password.style.border = '';
		if (!Utils.isAscii(password.value)) {
			has_error = true;
			alert("Only ASCII characters (A-Z, 0-9, Symbols) are allowed in your password");
		}
	} else {
		password.style.border = '2px solid red';
		has_error = true;
	}

	if (password_confirm.value) {
		password_confirm.style.border = '';
	} else {
		password_confirm.style.border = '2px solid red';
		has_error = true;
	}

	if (password.value != password_confirm.value) {
		password.style.border = '2px solid red';
		password_confirm.style.border = '2px solid red';
		has_error = true;
	}

	if (terms_of_use.checked) {
		terms_of_use_label.style.border = '';
	} else {
		terms_of_use_label.style.border = '2px solid red';
		has_error = true;
	}

	var gender = [];
	if (gender_m.checked) { gender.push('m'); }
	if (gender_f.checked) { gender.push('f'); }

	var lvl1 = [];
	if (level_uni.checked)   { lvl1.push('uni'); }
	if (level_jc.checked)    { lvl1.push('jc'); }
	if (level_hs.checked)    { lvl1.push('hs'); }
	if (level_ms.checked)    { lvl1.push('ms'); }
	if (level_club.checked)  { lvl1.push('club'); }
	if (level_other.checked) { lvl1.push('other'); }

	var lvl2 = [];
	if (level2_v.checked)   { lvl2.push('v'); }
	if (level2_jv.checked)  { lvl2.push('jv'); }
	if (level2_c18.checked) { lvl2.push('c18'); }
	if (level2_c16.checked) { lvl2.push('c16'); }
	if (level2_c14.checked) { lvl2.push('c14'); }
	if (level2_c12.checked) { lvl2.push('c12'); }

	if (has_error) {
		alert('Please fix the highlighted errors');
		return false;
	} else {
		var onNewUser = function(pair) {

			if (+pair[0] === 0) {
				alert(pair[2]);
				if (pair.length > 3) {
					window.location = pair[3];
				} else {
					window.location = target;
				}

			} else if (+pair[0] === 301) {

				if (pair.length == 3) {
					alert(pair[2]);
				}

				window.location = pair[1];

			} else {
				alert(pair[1]);

				// if this e-mail address already exists, redirect to
				// member subscriptions page
				if (pair[0] == 1) {
					window.location = '/member/subscriptions';
				}
			}
		};

		var onError = function () {
			alert('There was an error creating your account.');
		};

		var params = {
			fn       : first_name.value,
			ln       : last_name.value,
			em       : email.value,
			pw       : password.value,
			pos      : position.value,
			lvl1     : lvl1.join(),
			lvl2     : lvl2.join(),
			gender   : gender.join(),
			org      : org.value,
			city     : city.value,
			state    : state.value,
			regkind  : regkind.value,
			redirect : redirect.value,
			avcaemail: avcaemail.value,
			ps       : plan_selection,
			ps2      : plan_selection2,
			ps3      : plan_selection3,
			hf       : heard_from.value,
			hfd      : heard_from_detail.value
		};
		// Check query string, pathname, and redirect parameter for ws_game_plan
		const searchParams = new URLSearchParams(window.location.search);
		const redirectParam = searchParams.get('redirect') || '';

		if (window.location.search.indexOf('ws_game_plan') > -1 ||
		    window.location.pathname.indexOf('ws_game_plan') > -1 ||
		    redirectParam.indexOf('ws_game_plan') > -1){
			// coming from Rotate123 page
			params.app = 'rotate123';
		} else if ($('#regkind').val() === 'live'){
			// coming from SoloStats Live in-app browser registration
			params.app = 'solostatslive';
		}

		$.ajax({
			url      : "/q/register",
			type     : "post",
			dataType : "json",
			data     : params,
			error    : onError,
			success  : onNewUser
		});

	}

	return false;
}
